export default __webpack_public_path__ + "static/media/me.1f768127.jpg";